import React, { useState, useRef, useEffect } from 'react';
import { useGame } from '../context/GameContext';
import { KEY_ENTER, KEY_ESC } from '../utils/constants';

const Chat = () => {
    const [chatInput, setChatInput] = useState('');
    const chatInputRef = useRef(null);
    const { 
        chatMessages, 
        addChatMessage, 
        socket, 
        player, 
        isMobile,
        settings,
        updateSettings,
        startPingTimeRef
    } = useGame();

    useEffect(() => {
        if (!socket) return;

        const handleKeyPress = (e) => {
            if (e.keyCode === KEY_ENTER && document.activeElement.id !== 'chatInput') {
                chatInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [socket]);

    const handleKeyPress = (e) => {
        if (e.keyCode === KEY_ESC) {
            setChatInput('');
            chatInputRef.current?.blur();
            document.getElementById('cvs')?.focus();
        } else if (e.keyCode === KEY_ENTER) {
            handleSendMessage();
        }
    };

    const handleSendMessage = () => {
        if (!chatInput.trim() || !socket) return;

        const text = chatInput.replace(/(<([^>]+)>)/ig, '');
        
        if (text.indexOf('-') === 0) {
            // Handle commands
            const args = text.substring(1).split(' ');
            handleCommand(args[0], args.slice(1));
        } else {
            // Send regular message
            socket.emit('playerChat', { sender: player.name, message: text });
            addChatMessage(`<b>${player.name}</b>: ${text}`, 'me');
        }

        setChatInput('');
        document.getElementById('cvs')?.focus();
    };

    const handleCommand = (cmd, args) => {
        switch (cmd) {
            case 'ping':
                startPingTimeRef.current = Date.now();
                socket.emit('pingcheck');
                break;
            case 'dark':
                if (settings.backgroundColor === '#f2fbff') {
                    updateSettings('backgroundColor', '#181818');
                    updateSettings('lineColor', '#ffffff');
                    addChatMessage('Dark mode enabled.');
                } else {
                    updateSettings('backgroundColor', '#f2fbff');
                    updateSettings('lineColor', '#000000');
                    addChatMessage('Dark mode disabled.');
                }
                break;
            case 'border':
                updateSettings('borderDraw', !settings.borderDraw);
                addChatMessage(settings.borderDraw ? 'Hiding border.' : 'Showing border.');
                break;
            case 'mass':
                updateSettings('toggleMassState', settings.toggleMassState === 0 ? 1 : 0);
                addChatMessage(settings.toggleMassState === 0 ? 'Viewing mass enabled.' : 'Viewing mass disabled.');
                break;
            case 'continuity':
                updateSettings('continuity', !settings.continuity);
                addChatMessage(settings.continuity ? 'Continuity disabled.' : 'Continuity enabled.');
                break;
            case 'help':
                addChatMessage('-ping: Check your latency.');
                addChatMessage('-dark: Toggle dark mode.');
                addChatMessage('-border: Toggle visibility of border.');
                addChatMessage('-mass: Toggle visibility of mass.');
                addChatMessage('-continuity: Toggle continuity.');
                addChatMessage('-help: Information about the chat commands.');
                break;
            case 'login':
                socket.emit('pass', args);
                break;
            case 'kick':
                socket.emit('kick', args);
                break;
            default:
                addChatMessage('Unrecognized Command: -' + cmd + ', type -help for more info.');
        }
    };

    if (isMobile) return null;

    return (
        <div className="chatbox" id="chatbox">
            <ul id="chatList" className="chat-list">
                {chatMessages.map((msg, index) => (
                    <li key={index} className={msg.type}>
                        <span dangerouslySetInnerHTML={{ __html: msg.message }} />
                    </li>
                ))}
            </ul>
            <input
                id="chatInput"
                ref={chatInputRef}
                type="text"
                className="chat-input"
                placeholder="Chat here..."
                maxLength="35"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyDown={handleKeyPress}
            />
        </div>
    );
};

export default Chat;


